import { mapGoldenRaceSelections, mapGoldenRaceNestedBets } from './goldenRace';
import { mapOmniplaySelections } from './omniplay';
import { getOmniplayCopyBetData } from './omniplay/copyBet';
import { mapPascalSelections } from './pascal';

export const betTypeNameMap = {
  SystemMultiple: 'Systems',
};

export const gameNameSportAliasMap = {
  //GR
  Horse: "racing-horse",
  Dog: "racing-greyhounds",
  Champions: "Soccer",
  Spin2win: "Spin2win",
  Football: "Football",
  Keno: "Lottery",
  //PA
  Roulette: "Roulette",
  AutoRoulette: "AutoRoulette",
  AmericanRoulette: "Roulette",
  SpinToWIn: "SpinToWIn",
  SpinToWinDeluxe: "SpinToWinDeluxe",
  LightingSpinToWIn: "LightingSpinToWIn",
  VirtualGreyhoundRacing: "VirtualGreyhoundRacing",
  RealGreyhounds: "racing-greyhounds",
  DoubleWheel: "DoubleWheel",
  VirtualCycleRacing: "VirtualBicycle",
  VirtualMarbleRacing: "VirtualMarbleRacing",
  VirtualHorseRacing: "VirtualHorseRacing",
  DragRacing: "DragRacing",
  PenaltyKicks: "penalty",
  BetshopFootballLeague: "Soccer",
  HarnessRacing: "FutureHorseRacing",
};

const casinoMapper = {
  54: {
    mapSelections: mapGoldenRaceSelections,
    mapNestedBets: mapGoldenRaceNestedBets,
  },
  345: {
    mapSelections: mapPascalSelections,
  },
  261: {
    mapSelections: mapOmniplaySelections,
    getCopyBetData: getOmniplayCopyBetData,
  },
};

export const mapCasinoTicketSelections = (ticket) => {
  if (!ticket.casinoInfo) return [];

  const mapper = casinoMapper[ticket.casinoInfo.ProviderId]?.mapSelections;

  if (!mapper) return [];

  return mapper(ticket);
};

export const mapCasinoTicketNestedBets = (ticket) => {
  if (!ticket.casinoInfo) return [];

  const mapper = casinoMapper[ticket.casinoInfo.ProviderId]?.mapNestedBets;

  if (!mapper) return [];

  return mapper(ticket);
};

export const getCasinoCopyBetData = (ticket) => {
  if (!ticket.casinoInfo) return null;

  const getCopyBetData = casinoMapper[ticket.casinoInfo.ProviderId]?.getCopyBetData;

  if (!getCopyBetData) return null;

  return getCopyBetData(ticket);
};
